import React from 'react';
import List from '@material-ui/core/List';
import Collapse from '@material-ui/core/Collapse';
import SidebarItem from './SidebarItem';

const SidebarGroup = ({
	section,
	layer,
	expandedL1,
	expandedL2,
	onToggleGroup,
	activeItemKey,
	activeTrail,
	drawerOpen,
	onItemClick,
	onCollapsedGroupClick,
	cLanguage,
	forceL1Indent
}) => {
	const currentExpanded = layer === 1 ? expandedL1 : expandedL2;
	const isExpanded = currentExpanded === section.key;
	const hasActiveChild = activeTrail && activeTrail.includes(section.key) && activeItemKey !== section.key;

	const handleClick = () => {
		onToggleGroup(layer, section.key);
	};

	return (
		<>
			<SidebarItem
				section={section}
				layer={layer}
				active={false}
				hasActiveChild={hasActiveChild}
				drawerOpen={drawerOpen}
				expandable
				expanded={isExpanded}
				onClick={handleClick}
				cLanguage={cLanguage}
				forceL1Indent={forceL1Indent}
			/>
			<Collapse in={isExpanded} timeout="auto" unmountOnExit>
				<List component="div" disablePadding>
					{section.children.map((child) => {
						if (child.children) {
							return (
								<SidebarGroup
									key={child.key}
									section={child}
									layer={layer + 1}
									expandedL1={expandedL1}
									expandedL2={expandedL2}
									onToggleGroup={onToggleGroup}
									activeItemKey={activeItemKey}
									activeTrail={activeTrail}
									drawerOpen={drawerOpen}
									onItemClick={onItemClick}
									onCollapsedGroupClick={onCollapsedGroupClick}
									cLanguage={cLanguage}
								/>
							);
						}
						return (
							<SidebarItem
								key={child.key}
								section={child}
								layer={layer + 1}
								active={activeItemKey === child.key}
								hasActiveChild={false}
								drawerOpen={drawerOpen}
								onClick={() => onItemClick(child)}
								cLanguage={cLanguage}
							/>
						);
					})}
				</List>
			</Collapse>
		</>
	);
};

export default SidebarGroup;
